import React from "react";
import { Link } from "react-router-dom";

const BannerOne = () => {
  return (
    <section className="hero-banner position-relative overflow-hidden">
      {/* Background Image */}
      <img
        src="/assets/images/bg/banner-bg.png"
        alt="Grocery Delivery"
        className="hero-bg"
      />

      {/* Overlay */}
      <div className="hero-overlay"></div>

      <div className="container container-lg">
        <div className="hero-content text-center">
          <h1 className="hero-title">
            Fresh Groceries <br /> Delivered to Your Door
          </h1>

          <p className="hero-subtitle">
            Order daily essentials & get super-fast delivery at your doorstep.
          </p>

          <div className="hero-actions">
            <Link
              to="/shop"
              className="btn btn-main btn-lg rounded-pill d-inline-flex align-items-center gap-8"
            >
              Shop Now
              <i className="ph ph-shopping-cart-simple text-xl" />
            </Link>
          </div>

          {/* Hero Image */}
          <div className="hero-thumb">
            <img src="/assets/images/thumbs/banner-img1.png" alt="Groceries" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerOne;
